<template lang="pug">
AppProgressBar(
  :tracked="activity.overall"
  :total="100"
  :bar-color="barColor"
)
</template>

<script>
const ACTIVITY_COLORS = ['#ff3333', '#ffb10b', '#00d469'];

export default {
  name: 'ActivitiesProgressBar',
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    overallActivity() {
      return this.activity.overall;
    },
    formattedMouse() {
      return this.activity.mouse + '%';
    },
    barColor() {
      let index = 0;

      if (this.overallActivity > 50) {
        index = 2;
      } else if (this.overallActivity > 20) {
        index = 1;
      }

      return ACTIVITY_COLORS[index];
    },
  },
};
</script>
